define('environment',[
    'module'
], function (module) {
	'use strict';
    return module.config();
});
